(function () {
	'use strict';

	/**
	 * @ngdoc component
	 * @name mx.components:mxDropdownMenu
	 * @module mx.components
	 *
	 * @description
	 * Implement a button with dropdown menu for some actions
	 *
	 * The following example shows hot to use mxDropdownMenu.
	 * mxDropdownMenu expects next attributes:
	 *   1) icon - font icon for button which opens dropdown menu.
	 *        Value must be the name of the icon in a ligature-based icon font ( https://material.angularjs.org/latest/#/api/material.components.icon/directive/mdIcon )
	 *   2) icon-src - source for the icon for button which opens dropdown menu.
	 *        Value must be either the icon URL (full or a path on the same server) or a name of an icon (possibly with an icon set name) registered via $mdIconProvider
	 *        (same as md-svg-src attribure of md-icon). Ignored if icon attribute is set.
	 *   3) items - an array of objects with keys: 'icon', 'label', 'onItemClick', 'htmlClass'
	 *        3.1) icon - an icon on item (not mandatory)
	 *        3.2) iconSrc - an icon source (URL or registered icon name, not mandatory)
	 *        3.3) label - a text label on item (not mandatory)
	 *        3.4) onItemClick - a function, which will be executed when item is selected in dropdown menu
	 *        3.5) htmlClass - can be used if we need to identify dropdown-item in DOM-model (not mandatory)
	 *        3.6) hidden - hide if `true`
	 *   4) expanded - if pass 'true' - then dropdown menu will be opened automatically. It's also possible to read value to get know if dropdown menu is expanded.
	 *   5) hideButton - if 'true' - open-button will be hidden (for example if we want to trigger dropdown menu expanding by some other event)
	 *
	 * Example 1:
	 * Assume we have an array of items like this:
	 * ```js
	 * vm.menuItems = [{
	 *		icon: 'save',
	 *		label: 'Save',
	 *		onItemClick: function() {alert('saved!'); }
	 *	}, {
	 *		icon: 'social:android',
	 *		label: 'Load on phone',
	 *		onItemClick: function() {alert('Loaded!'); }
	 *	}, {
	 *		iconSrc: '/path/to/icon.svg?v=1.1',
	 *		label: 'Do something',
	 *		onItemClick: function() {alert('Done!'); }
	 *	},
	 *    ...
	 * ];
	 *```
	 *
	 * Then html will be like this:
	 * ```html
	 * <mx-dropdown-menu
	 *        icon="vertical-dots"
	 *        items="vm.menuItems"
	 *        context="vm">
	 * </mx-dropdown-menu>
	 * ```
	 * If "context" attribute is passed, then "onItemClick" will be executed in this passed context.
	 *
	 * Example 2:
	 * ```html
	 * <button ng-click="vm.isOpen = !vm.isOpen">My Button</button>
	 * ...
	 * <mx-dropdown-menu
	 *        icon="vertical-dots"
	 *        items="vm.menuItems"
	 *        hide-button="true"
	 *        expanded="vm.isOpen">
	 * </mx-dropdown-menu>
	 * ```
	 *
	 **/

	angular.module('mx.components').component('mxDropdownMenu', {
		bindings: {
			icon: '@',
			iconSrc: '@',
			items: '<',
			expanded: '=?', // here 2-way binding is important because login of closing dropdown-menu placed inside this directive
			hideButton: '@',
			context: '<',
			loadItems: '&',
			event: '<',
			disabled: '<',
		},
		controller: MxListCtrl,
		controllerAs: 'vm',
		templateUrl: 'mx-dropdown-menu/mx-dropdown-menu.html',
	});

	MxListCtrl.$inject = ['$q', '$document', '$scope', '$element', '$mdUtil'];

	function MxListCtrl($q, $document, $scope, $element, $mdUtil) {
		var vm = this;
		var itemsLoaded = false;

		vm.$onInit = function () {
			vm.hideButton = (vm.hideButton || 'false').toLowerCase();
			vm.handleClick = handleClick;
		};

		$scope.$on('$mdMenuClose', function () {
			window.setTimeout(function () {
				$($document[0].documentElement).removeClass('grid-menu-opened');
				vm.expanded = false;
			}, 250);
			if (menuContainer) {
				menuContainer.removeEventListener('click', _menuClickHandler, true);
			}
		});

		$scope.$watch('vm.expanded', function () {
			if (vm.expanded && !vm.__preventSecondOpening) {
				window.setTimeout(function () {
					var clickEvent = new $.Event('click');
					var pos = $element.offset();
					$element.find('.mx-dropdown-menu-open-button').trigger(
						$.extend(clickEvent, {
							clientX: Math.round(pos.left),
							clientY: Math.round(pos.top),
						})
					);
				});
			} else if (!vm.expanded) {
				vm.__preventSecondOpening = false;
			}
		});

		var menuContent = $element.find('.mx-dropdown-menu-list')[0];
		var menuContainer;

		function _menuClickHandler(e) {
			var target = e.target;
			if (target === menuContent) {
				return;
			}
			var menuItem = $mdUtil.getClosest(target, 'md-menu-item');
			if (menuItem.classList.contains('disable-menu-closing')) {
				e.stopPropagation();
				angular.element(target).triggerHandler('click');
			}
			$scope.$evalAsync(function () {
				vm.expanded = false;
			});
		}

		vm.openMenu = function ($mdOpenMenu, $event) {
			$mdOpenMenu();
			_prepareItems();
			_setMenuPosition($event);
			if (!vm.expanded) {
				// It means the dropdown-menu was opened by clicking on button in template,
				// but not by changing `vm.expanded` to `true` programmatically.
				// So we need to prevent second opening
				vm.__preventSecondOpening = true;
				vm.expanded = true;
			}
			setTimeout(function () {
				if (menuContainer) {
					menuContainer = menuContent.parentElement;
					menuContainer.addEventListener('click', _menuClickHandler, true);
				}
			}, 200);
		};

		function _prepareItems() {
			if (!itemsLoaded) {
				itemsLoaded = true;
				var items = vm.loadItems({ context: vm.context });
				if (items) {
					$q.when(items).then(function (items) {
						vm.items = items;
					});
				}
			}
		}

		function _setMenuPosition($event) {
			var event = vm.event || $event;
			$($document[0].documentElement).addClass('grid-menu-opened');
			if (event && event.clientX) {
				var head = $($document[0].head);
				var style = $('.grid-menu-position')[0];
				if (!style) {
					style = $('<style class="grid-menu-position"/>');
					head.append(style);
				} else {
					style = $(style);
				}
				var left = event.clientX;
				var top = event.clientY;
				style.html('.grid-menu-opened .md-open-menu-container { left: ' + left + 'px !important; top: ' + top + 'px !important; }');
				var _oldMenuWidth;
				var _handleRightShift = function () {
					var menu = $('.md-open-menu-container:visible');
					var width = menu.width();
					if (!width || _oldMenuWidth !== width) {
						_oldMenuWidth = width;
						window.setTimeout(_handleRightShift, 100);
					}
					var menuWidth = Math.round(Math.max(width, 270));
					var menuHeight = menu.height();

					if (event.clientX + menuWidth > window.innerWidth) {
						left = window.innerWidth - menuWidth - 20;
					}

					if (menuHeight + event.clientY > window.innerHeight) {
						top = window.innerHeight - menuHeight - 20;
					}

					if (left !== event.clientX || top !== event.clientY) {
						style.html('.grid-menu-opened .md-open-menu-container { left: ' + left + 'px !important; top: ' + top + 'px !important; }');
					}
				};
				_handleRightShift();
			}
		}

		function handleClick(event, item) {
			item.onItemClick.call(vm.context, event, item);
		}

		return vm;
	}
})(window);
